import { GEO_DATA } from "./geo";
import { FieldEntity, FieldQueryType } from "@/types";
import { CondOperator } from "./enum";

function formatGeoData() {
  const newData: Array<any> = [];

  function getItem(data: any, items: Array<any>) {
    const item: any = {};
    item.name = item.id = data.v;
    if (data.c && data.c.length) {
      item.children = [];
      data.c.forEach((c: any) => getItem(c, item.children));
    }
    items.push(item);
  }

  (JSON.parse(JSON.stringify(GEO_DATA)) as Array<any>).forEach((data: any) => getItem(data, newData));
  return newData;
}

export const DEFAULT_DATE_FIELDS: Array<FieldEntity> = [
  { name: "appDate", label: "申请日" },
  { name: "pubDate", label: "公开（公告）日" },
  { name: "authDate", label: "授权日" },
  { name: "modifiedTime", label: "导入时间" },
];

export const DEFAULT_DATE_QUERY_TYPES: Array<FieldQueryType> = [
  { name: "range", label: "按起止日期检索" },
  { name: "year", label: "按指定年份检索" },
];

export const DEFAULT_TEXT_FIELDS: Array<FieldEntity> = [
  { name: "patentNo", label: "申请号" },
  { name: "title", label: "专利名称" },
  { name: "applicantName", label: "申请人(原始)" },
  { name: "applicantNewName", label: "申请人(修改后)" },
  { name: "inventorName", label: "发明人(原始)" },
  { name: "inventorNewName", label: "发明人(修改后)" },
  { name: "primaryIpc", label: "主分类号" },
  { name: "legalStatus", label: "法律状态" },
  { name: "agencyName", label: "代理机构" },
];

export const DEFAULT_DATE_PICKER_OPTIONS: any = {
  shortcuts: [
    {
      text: "未来一周",
      onClick(picker: any) {
        const start = new Date();
        const end = new Date();
        end.setDate(end.getDate() + 7);
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "未来一个月",
      onClick(picker: any) {
        const start = new Date();
        const end = new Date();
        end.setMonth(end.getMonth() + 1);
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "未来三个月",
      onClick(picker: any) {
        const start = new Date();
        const end = new Date();
        end.setMonth(end.getMonth() + 3);
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "之前一周",
      onClick(picker: any) {
        const start = new Date();
        start.setDate(start.getDate() - 7);
        const end = new Date();
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "之前一个月",
      onClick(picker: any) {
        const start = new Date();
        start.setMonth(start.getMonth() - 1);
        const end = new Date();
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "之前三个月",
      onClick(picker: any) {
        const start = new Date();
        start.setMonth(start.getMonth() - 3);
        const end = new Date();
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "今年全年",
      onClick(picker: any) {
        const start = new Date();
        start.setMonth(0);
        start.setDate(1);

        const end = new Date();
        end.setMonth(11);
        end.setDate(31);

        picker.$emit("pick", [start, end]);
      },
    },
  ],
};

export declare interface QueryField {
  name: string;
  label: string;
  type: string;
  enumKey?: string;
  enumValues?: Array<string>;
  treeData?: Array<any>;
}

export declare interface QueryFieldGroup {
  name: string;
  fields: Array<QueryField>;
}

export const ADV_QUERY_FIELD_GROUPS: Array<QueryFieldGroup> = [
  {
    name: "号码/名称",
    fields: [
      { name: "patentNo", label: "申请号", type: "text" },
      { name: "pubNo", label: "公开（公告）号", type: "text" },
      { name: "title", label: "专利名称", type: "text" },
      { name: "priorityPatents", label: "优先权", type: "text" },
      { name: "inteAppNo", label: "国际申请号", type: "text" },
      { name: "intePubNo", label: "国际公布号", type: "text" },
    ],
  },
  {
    name: "人员/机构",
    fields: [
      { name: "patentee", label: "当前专利权人", type: "text" },
      { name: "applicants", label: "申请人", type: "text" },
      { name: "applicantName", label: "申请人(原始)", type: "text" },
      { name: "applicantNewName", label: "申请人(修改后)", type: "text" },
      { name: "primaryApplicantName", label: "主申请人(原始)", type: "text" },
      { name: "primaryApplicantNewName", label: "主申请人(修改后)", type: "text" },
      { name: "inventors", label: "发明人", type: "text" },
      { name: "inventorName", label: "发明人(原始)", type: "text" },
      { name: "inventorNewName", label: "发明人(修改后)", type: "text" },
      { name: "primaryInventorName", label: "主发明人(原始)", type: "text" },
      { name: "primaryInventorNewName", label: "主发明人(修改后)", type: "text" },
      { name: "agencyName", label: "代理机构", type: "text" },
      { name: "agentName", label: "代理人", type: "text" },
    ],
  },
  {
    name: "日期",
    fields: [
      { name: "modifiedTime", label: "导入时间", type: "date" },
      { name: "appDate", label: "申请日", type: "date" },
      { name: "pubDate", label: "公开（公告）日", type: "date" },
      { name: "authDate", label: "授权日", type: "date" },
      { name: "inteAppDate", label: "国际申请日", type: "date" },
      { name: "intePubDate", label: "国际公布日", type: "date" },
    ],
  },
  {
    name: "分类号",
    fields: [
      { name: "primaryIpc", label: "IPC主分类", type: "text" },
      { name: "miniIpc", label: "IPC小类", type: "text" },
      { name: "shortIpc", label: "IPC大类", type: "text" },
      { name: "ipc", label: "IPC分类号", type: "text" },
      { name: "cpc", label: "CPC", type: "text" },
      { name: "ecla", label: "ECLA", type: "text" },
    ],
  },
  {
    name: "类型/状态",
    fields: [
      { name: "patentType", label: "专利类型", type: "enum", enumKey: "PatentType" }, // FM("发明"),SYXX("实用新型"),WG("外观");
      { name: "legalStatus", label: "法律状态", type: "text" },
    ],
  },
  {
    name: "国家/地区",
    fields: [
      { name: "country", label: "专利所属国", type: "text", enumValues: ["中国", "美国", "日本", " 韩国"] }, // 中国 美国 日本 韩国
      { name: "applicantCountry", label: "申请国", type: "text", enumValues: ["中国", "美国", "日本", " 韩国"] },
      { name: "applicantGeo", label: "省/市/区县", type: "tree", treeData: formatGeoData() }, // geo.ts
      { name: "applicantAddress", label: "地址", type: "text" },
    ],
  },
];

export const ADV_QUERY_OPERATORS = {
  text: [
    [CondOperator.EQUAL, "="],
    [CondOperator.NOT_EQUAL, "<>"],
    [CondOperator.LIKE, "包含"],
    [CondOperator.NOT_LIKE, "不包含"],
    [CondOperator.LEFT_LIKE, "开头是"],
    [CondOperator.RIGHT_LIKE, "结尾是"],
    [CondOperator.NULL, "为空"],
    [CondOperator.NOT_NULL, "不为空"],
  ],
  date: [
    [CondOperator.BETWEEN, "区间"],
    [CondOperator.LT, "早于"],
    [CondOperator.GT, "晚于"],
    [CondOperator.NULL, "为空"],
    [CondOperator.NOT_NULL, "不为空"],
  ],
  enum: [
    [CondOperator.IN, "包含"],
    [CondOperator.NOT_IN, "不包含"],
    [CondOperator.NULL, "为空"],
    [CondOperator.NOT_NULL, "不为空"],
  ],
  tree: [
    [CondOperator.BELONG_TO, "隶属于"],
    [CondOperator.IN, "包含"],
    [CondOperator.NOT_IN, "不包含"],
    [CondOperator.NULL, "为空"],
    [CondOperator.NOT_NULL, "不为空"],
  ],
};
